import gsap from 'gsap'
import { forEach } from 'lodash'

import { batchRevealAnimation } from './shared'
import { Animation } from '@/types'

export const timelineRevealAnimation = ({
  node,
  mobile,
  context,
  reverse
}: Animation) => {
  if (mobile) return

  const selector = context?.selector || gsap.utils.selector(node)

  const titles = selector('[data-motion-title]')
  const overlines = selector('[data-motion-overline]')

  let overlinesBatchAnimation: ScrollTrigger[]
  if (overlines.length > 0) {
    overlinesBatchAnimation = batchRevealAnimation({
      targets: overlines,
      reverse,
      stagger: {
        amount: 0.12
      }
    })
  }

  let titlesBatchAnimation: ScrollTrigger[]
  if (overlines.length > 0) {
    titlesBatchAnimation = batchRevealAnimation({
      targets: titles,
      reverse,
      stagger: {
        amount: 0.24
      }
    })
  }

  return () => {
    forEach(overlinesBatchAnimation || [], (animation) => animation.kill())
    forEach(titlesBatchAnimation || [], (animation) => animation.kill())
  }
}
